import React, { useEffect, useState } from 'react'
import { fetchJobDetails } from '../../services/auth.service';
import { useDispatch, useSelector } from 'react-redux';
import { jobId, setLoader } from '../../slice/commonSlice';
import JobDetailsServices from './JobDetailsServices';
import JobDetailProvider from './JobDetailProvider';

const JobDetails = () => {
  const dispatch = useDispatch();
  const [details, setDetails] = useState({});
  let id = useSelector(jobId);
  useEffect(()=>{
    if(id){
      fetchJob()
    }
  },[id])
  const fetchJob = async () => {
    let payload = {
      "id": id
    }
    await dispatch(setLoader(true));
    try {
      const response = await fetchJobDetails(payload);
      await dispatch(setLoader(false));
      let [job] = response.data?.jobData
      setDetails(job);
    } catch (error) {
      await dispatch(setLoader(false));
      console.error("Error fetching data:", error);
    }
  }
  return (
    <>
    {
      details?.jobType === 'services' ? <JobDetailsServices details={details} /> : null
    }
    {
      (details?.jobType === 'moving' || details?.jobType === 'delivery') ? <JobDetailProvider fetchDetails={fetchJob} details={details} /> : null
    }
    </>
  )
}

export default JobDetails
